import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        popover: {
            placement: 'top',
            arrowShadowColor: 'transparent',
            arrowPadding: 309,
            offset: [-153, 15],
        },
        container: {
            bg: 'background.strong.default',
            borderRadius: 'large',
            boxShadow:
                '0 2px 4px 0 var(--chakra-shadows-neutral-xs), 0 6px 12px 0 var(--chakra-shadows-neutral-xs) !important',
            transition: 'box-shadow 0.3s ease',
            border: 'none',
            maxWidth: remCalc(288),
            '--popper-bg': 'var(--chakra-colors-background-strong-default)',
            '--popper-arrow-bg': 'var(--chakra-colors-background-strong-default)',
            '--popper-arrow-shadow-color': 'transparent',
            '--popper-arrow-size': remCalc(12),
        },
        arrow: {
            bg: 'background.strong.default',
        },
        body: {
            padding: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
        },
        hstack: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
            alignSelf: 'stretch',
        },
        title: {
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
        },
        description: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            overflowWrap: 'anywhere',
        },
        texts: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(4),
            alignItems: 'flex-start',
            justifyContent: 'center',
            color: 'foreground.neutral.inverse',
        },
        ctaLinks: {
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
        },
        infoIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.inverse',
        },
    },
    variants: {
        'top-right': {
            popover: {
                placement: 'top',
                arrowPadding: 3,
                offset: [120, 15],
                left: '-2px',
            },
            arrow: {
                left: '-2px !important',
            },
            container: {
                marginBottom: '0',
            },
        },
        'bottom-right': {
            popover: {
                placement: 'bottom',
                arrowPadding: 0,
                offset: [153, 15],
            },
        },
        'top-left': {
            popover: {
                placement: 'top',
                arrowPadding: 244,
                offset: [-118, 15],
            },
        },
        'top-left-no-y-offset': {
            popover: {
                placement: 'top',
                arrowPadding: 244,
                offset: [-105, 0],
            },
        },
        'bottom-left': {
            popover: {
                placement: 'bottom',
                arrowPadding: 244,
                offset: [-120, 15],
            },
        },
        'right-bottom': {
            popover: {
                placement: 'right',
                arrowPadding: 8,
                offset: [25, 6],
            },
        },
        'right-top': {
            popover: {
                placement: 'right',
                arrowPadding: 8,
                offset: [-25, 6],
            },
        },
        'left-bottom': {
            popover: {
                placement: 'left',
                arrowPadding: 8,
                offset: [-25, 6],
            },
        },
        'left-top': {
            popover: {
                placement: 'left',
                arrowPadding: 8,
                offset: [-25, 6],
            },
        },
        'right-center': {
            popover: {
                placement: 'right',
                arrowPadding: 8,
                offset: [0, 3],
            },
        },
        'left-center': {
            popover: {
                placement: 'left',
                arrowPadding: 8,
                offset: [0, 5],
            },
        },
        'more-information': {
            popover: {
                placement: 'bottom',
            },
        },
        'service-card': {
            popover: {
                placement: 'left',
            },
        },
    },
    parts: [
        'popover',
        'container',
        'arrow',
        'body',
        'hstack',
        'title',
        'description',
        'texts',
        'ctaLinks',
        'infoIcon',
    ],
}
